import React from "react";
import ReactDOM from "react-dom";
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle';
import "./index.css";
import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));
